import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { Location, BaseLocation } from '../../../../../core/interfaces/location';
import { TranslocoPipe } from '@jsverse/transloco';
import { CustomButtonComponent } from '../../../../../shared/components/custom-button/custom-button.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-create-location-dialog',
  standalone: true,
  imports: [FormsModule, DialogModule, TranslocoPipe, CustomButtonComponent, CommonModule],
  templateUrl: './create-location-dialog.component.html',
  styleUrl: './create-location-dialog.component.css'
})
export class CreateLocationDialogComponent {
  visible: boolean = false;
  private dialogResponsePromise!: (value: boolean) => void;

  constructor() { }

  openModal(): Promise<boolean> {
    this.visible = true;

    return new Promise<boolean>((resolve) => { this.dialogResponsePromise = resolve; });
  }

  closeModal(dialogResponse: boolean): void {
    this.visible = false;
    this.dialogResponsePromise(dialogResponse);
  }

  confirmAddLocation(): void {
    this.closeModal(true)
  }
}
